<template>
    <div>
        <!-- 注：添加操作时，当左边没有树的值传入时，添加需要默认清空内容defaultEmpty，但包含树图或有内容传入时需要去掉该属性 -->
        <base-form-plus :isAdd="formInfo.isAdd" :relationDialogVisible.sync="formInfo.dialogVisible" showTitle="模板包表"
                  :showData="formInfo.editData"
                  :rules="rules" @submitAdd="submitAdd" @submitEdit="submitEdit" ref="baseForm" defaultEmpty>
            <!-- 插槽部分 -->
            <template v-slot:default="{ruleForm}" class="info">
                        <!-- 模板包名称 -->
                        <el-form-item :label="columnInfo.packageName.label" prop="packageName">
                                <el-input v-model="ruleForm.packageName" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 模板包编码 -->
                        <el-form-item :label="columnInfo.packageCode.label" prop="packageCode">
                                <el-input v-model="ruleForm.packageCode" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 模板包存储路径 -->
                        <el-form-item :label="columnInfo.packagePath.label" prop="packagePath">
                                <el-input v-model="ruleForm.packagePath" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 描述 -->
                        <el-form-item :label="columnInfo.description.label" prop="description">
                                <el-input v-model="ruleForm.description" placeholder="请输入内容"  clearable></el-input>
                        </el-form-item>
                        <!-- 状态 -->
                        <el-form-item :label="columnInfo.state.label" prop="state">
                                <enum-dict-select v-model="ruleForm.state" module-name="data" dict-code="state"></enum-dict-select>
                        </el-form-item>
            </template>
        </base-form-plus>
    </div>
</template>

<script>
    /**
     * 	模板包表表单
     * 	@author PeterLee
     * 	@since 2026-01-31
     */
    import {mapState, mapMutations, mapActions} from "vuex";

    export default {
        name: 'templatePackageForm',
        // 计算操作
        computed: {
            ...mapState({
                // 校验规则
                rules: state => state.data.templatePackage.rules,
                // 表格数据
                tableData: state => state.data.templatePackage.tableData,
                // 表单信息
                formInfo: state => state.data.templatePackage.formInfo,
                // 下拉选项
                options: state => state.data.templatePackage.options,
                // 列信息
                columnInfo: state => state.data.templatePackage.columnInfo,
            })
        },
        methods: {
            ...mapMutations({
                setDialogVisible: 'data/templatePackage/setDialogVisible',
            }),
            ...mapActions({
                submitAdd: 'data/templatePackage/submitAdd',
                submitEdit: 'data/templatePackage/submitEdit',
            })
        }
    }
</script>

<style lang="less" scoped>
    .info {
        display: flex;
        flex-wrap: wrap;

        .el-form-item {
            width: 50%;
        }
    }
</style>
